/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const EvaluationSummary = {

	get (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/evaluation-summary"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getCommittee (context, committeeId, onSuccess, onError, options) {
		Api.get(context,
			"/evaluation-summary/committee"
			+ "?committeeId=" + committeeId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	put (context, evaluationSummaryDTO, onSuccess, onError, options) {
		Api.put(context,
			"/evaluation-summary"
			, evaluationSummaryDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
